var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86689 5.61366C6.41706 5.61366 7.67372 4.357 7.67372 2.80683C7.67372 1.25666 6.41706 0 4.86689 0C3.31672 0 2.06006 1.25666 2.06006 2.80683C2.06006 4.357 3.31672 5.61366 4.86689 5.61366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9544 6.29195C5.94114 6.29159 5.92789 6.29123 5.91464 6.29102H3.8189C1.66973 6.33142 -0.0396988 8.10646 0.000701611 10.2556C0.000916507 10.2689 0.0012747 10.2821 0.00163286 10.2954V10.8942C0.00163286 11.1936 0.113879 11.5304 0.450693 11.5304H9.28285C9.61966 11.5304 9.73191 11.1936 9.73191 10.8942V10.2954C9.7943 8.14672 8.10307 6.35434 5.9544 6.29195Z",
    fill: "#8292E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.46484,
    y: 7.99902,
    width: 1.46693,
    height: 4.40078,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99902,
    y: 9.46484,
    width: 4.40078,
    height: 1.46693,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAdmin);
export default __webpack_public_path__ + "static/media/sub-admin.64e60ef2.svg";
export { ForwardRef as ReactComponent };